import React from 'react';
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Buttons from '../../components/utils/buttonsContainer/Buttons';
import HeaderButton from '../../components/utils/button/HeaderButton';
import reload from "../../assets/icons/actualizar.svg";
import { FiltrosStyles } from '../Filtros.styles';
import { SubmitButtonStyles } from '../../components/utils/button/SubmitButton.styles';

export default function Filtros(props) {
    const {
        filtros,
        setFiltros,
        cargando,
        onSearch
    } = props;

    const classes = FiltrosStyles();
    const buttonClasses = SubmitButtonStyles();

    const handleChange = (field) => (event) => {
        setFiltros({
            ...filtros,
            [field]: event.target.value
        });
    };

    const handleSubmit = (e) => {
        e?.preventDefault?.();
        if (typeof onSearch === 'function') onSearch();
    };

    return (
        <div className={classes.root}>
            <div className={classes.filtros}>
                <TextField
                    label="Fecha"
                    name="cobroTransferenciaFecha"
                    type="date"
                    className={classes.input}
                    value={filtros.cobroTransferenciaFecha}
                    onChange={handleChange('cobroTransferenciaFecha')}
                    disabled={cargando}
                    InputLabelProps={{ shrink: true }}
                />
                <TextField
                    label="Monto"
                    name="cobroTransferenciaMonto"
                    type="number"
                    className={classes.input}
                    value={filtros.cobroTransferenciaMonto}
                    onChange={handleChange('cobroTransferenciaMonto')}
                    disabled={cargando}
                    InputLabelProps={{ shrink: true }}
                />
                <TextField
                    label="CUIT origen"
                    name="cobroTransferenciaCUITOrigen"
                    className={classes.input}
                    value={filtros.cobroTransferenciaCUITOrigen}
                    onChange={handleChange('cobroTransferenciaCUITOrigen')}
                    disabled={cargando}
                    InputLabelProps={{ shrink: true }}
                />
                <TextField
                    label="Referencia"
                    name="cobroTransferenciaReferencia"
                    className={classes.input}
                    value={filtros.cobroTransferenciaReferencia}
                    onChange={handleChange('cobroTransferenciaReferencia')}
                    disabled={cargando}
                    InputLabelProps={{ shrink: true }}
                />
                <Button
                    type="button"
                    className={buttonClasses.root}
                    onClick={handleSubmit}
                    disabled={cargando}
                >
                    Buscar
                </Button>
            </div>
            <Buttons updateList={onSearch}>
                <HeaderButton
                    text={"Actualizar pagina"}
                    icon={reload}
                    updateList={onSearch}
                />
            </Buttons>
        </div>
    );
}

